module.exports = __webpack_public_path__ + "img/sirkel_postmodernisme.c03bdbbf.png";